'use strict';

var React = require('react');
var ReactRedux = require('react-redux');
var Store = require('../../redux/store');
var reactDom = require('react-dom');

if (window.APP  == "pedido-agil") {
    const PedidoAgilComponent = require('../../views/order-agil/index').OrderAgilHome;
    const store = Store.createCartStore(window.REDUX_DATA);
    const app = document.getElementById("root");

     const renderMethod = module.hot ? reactDom.render : reactDom.hydrate;
    renderMethod(
        <ReactRedux.Provider suppressHydrationWarning={true} store={store}>
            <PedidoAgilComponent />
        </ReactRedux.Provider>,
        app
    );
}